import { render } from "./MWUpdateFooter.vue?vue&type=template&id=31139b00"
import script from "./MWUpdateFooter.vue?vue&type=script&lang=js"
export * from "./MWUpdateFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__